import React, { useEffect, createElement } from 'react';
import { CountdownBar } from './components/CountdownBar';
import { HeroSection } from './components/HeroSection';
import { RealitySection } from './components/RealitySection';
import { SolutionSection } from './components/SolutionSection';
import { PreviewSection } from './components/PreviewSection';
import { BonusSection } from './components/BonusSection';
import { DifferentiatorSection } from './components/DifferentiatorSection';
import { PricingSection } from './components/PricingSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ResultsSection } from './components/ResultsSection';
import { FAQSection } from './components/FAQSection';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  useEffect(() => {
    const pixelId = '2032586933980278';
    try {
      // @ts-ignore
      if (window.fbq) return;
      // @ts-ignore
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      // @ts-ignore
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
      // @ts-ignore
      fbq('init', pixelId);
      // @ts-ignore
      fbq('track', 'PageView');
    } catch (e) {
      console.warn('Meta Pixel failed to load:', e);
    }
  }, []);
  return <div className="min-h-screen bg-[#FFF8F0] font-sans text-gray-900" data-id="element-0">
      <CountdownBar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <RealitySection data-id="element-4" />
        <SolutionSection data-id="element-5" />
        <PreviewSection data-id="element-6" />
        <BonusSection data-id="element-7" />
        <DifferentiatorSection data-id="element-8" />
        <TestimonialsSection data-id="element-9" />
        <ResultsSection data-id="element-10" />
        <PricingSection data-id="element-11" />
        <FAQSection data-id="element-12" />
      </main>

      <footer className="bg-[#3D1F2E] text-[#C9A0B0] py-8 text-center text-sm" data-id="element-13">
        <div className="max-w-6xl mx-auto px-4" data-id="element-14">
          <p data-id="element-15">
            © {new Date().getFullYear()} MegaPack Estética Integral. Todos los
            derechos reservados.
          </p>
          <p className="mt-2 text-xs" data-id="element-16">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio no está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>

      <SocialProofPopup data-id="element-17" />

      <noscript data-id="element-18">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=2032586933980278&ev=PageView&noscript=1" alt="" data-id="element-19" />
      </noscript>
    </div>;
}